// extracted by mini-css-extract-plugin
module.exports = {"CaseStudy":"style_CaseStudy__AjvMw","ProjectsWrapper":"style_ProjectsWrapper__1vPP_"};